var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "modalAnimation" } }, [
    _vm.showModal
      ? _c(
          "div",
          {
            staticClass: "modal",
            class: _vm.modalClasses,
            on: {
              keydown: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "esc", 27, $event.key, [
                    "Esc",
                    "Escape"
                  ])
                )
                  return null
                return _vm.closeModal(false)
              }
            }
          },
          [
            _c("div", { staticClass: "modal__overlay" }),
            _c(
              "div",
              { staticClass: "modal__content" },
              [
                _vm.canClose
                  ? _c(
                      "div",
                      {
                        staticClass: "modal__close",
                        on: {
                          click: function($event) {
                            return _vm.closeModal(false)
                          }
                        }
                      },
                      [
                        _c("svgicon", {
                          staticClass: "svg-icon-action",
                          attrs: { icon: "delete", height: "18" }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._t("modalContent")
              ],
              2
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }